<template>
  <footer>
    <ul class="footer-nav">
      <li class="footer-li">
        <a
          href="https://tb.53kf.com/code/client/c37bc8c2ff1993757aa0a040bf97ba956/1"
        >
          <!-- <img src="http://www.biaowu.com/static/m/images/icon52.png" alt /> -->
          <img src="@/assets/img/common/icon52.png" alt="" />
          客服
        </a>
      </li>
      <li class="footer-li">
        <a href="javascript:;" id="collect" @click="collectAction">
          <img
            src="https://beinabncc.oss-cn-beijing.aliyuncs.com/file//icon5320210417.png"
            v-if="!isFav"
          />
          <!-- src="http://www.biaowu.com/static/m/images/icon53.png" -->
          <img
            src="https://beinabncc.oss-cn-beijing.aliyuncs.com/file//icon53-120210417.png"
            v-else
            alt=""
          />
          <!-- src="http://www.biaowu.com/static/m/images/icon53_1.png" -->

          <!-- <#if isFav?? && isFav>
                    <img src="http://www.biaowu.com/static/m/images/icon53_1.png" alt="">
                    <#else>
                    <img src="http://www.biaowu.com/static/m/images/icon53.png" alt="">
                </#if>-->
          收藏
        </a>
      </li>
      <li
        id="add"
        :class="{
          'footer-li button': true,buttonHide: viewCartText != '查看购物车'&& viewCartText != '免费试用',
        }"
        style="background-color: #df0024;"
      >
        <a href="javascript:;" @click="addShopCar(pid, Number(tid), 1, lotid,tcid, stock,2)"
          >加入购物车</a
        >
      </li>
      <li class="footer-li button" style="margin-right: 0">
        <a href="javascript:;"  v-if="buttonType ==0" @click="detailToApplyOrder(pid,lotid)">免费试用</a>
        <a href="javascript:;"  v-else-if="buttonType ==1" @click="toViewCart">查看购物车</a>
        <a href="javascript:;"  v-else @click="standarddownloadcheck">{{viewCartText }}</a>
      </li>
    </ul>
    <img src="@/assets/img/common/icon53_1.png" id="collectImg" v-show="false" alt="">
  </footer>
</template>

<script lang="ts">
import { defineComponent,inject, PropType } from "vue";

import api from "@/api/axios";
import Toast from "@/components/UI/Toast/";
import useShopCar from "@/hooks/useShopCar";
import $ from "jquery";
import Modal from "@/components/UI/Modal";
import router from "@/router";
export default defineComponent({
  name: "slotFooter",
  props: {
    tid: {
      type: String,
      default: "",
    },
    pid: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "1",
    },
    isFav: {
      type: Boolean,
      default: false,
    },
    viewCartText: {
      type: String,
      default: "查看购物车",
    },
    lotid: {
      type: String,
      default: "0"
    },
    tcid: {
      type: String,
      default: "0"
    },
    stock: {
      type: Number,
      default: null
    },
    buttonType:{
      type:Number,
      default:1
    }
  },
  setup(props) {
    //  add shop car
    const { addShopCar ,storgeBackstage} = useShopCar();
    const userInfo = inject("userInfo") as any;
    //查看购物车
    function toViewCart() {

        router.push({name: "ShopCar"});

    }
    //去申请试用
    function detailToApplyOrder(pid: any, lotid: any) {

        storgeBackstage(pid, 0, 1,lotid,0,2,1,0);
        //子组件中修改父组件传递过来的值
        this.$emit('update:buttonType', 1)

    }
    function collectAction() {
      const formData = new FormData();
      formData.append("id", props.pid);
      formData.append("type", props.type);
      api
        .post("/M/Server/Collection", formData, {
          params: {
            validate: true,
          },
        })
        .then((res) => {
          if (res) {
            Toast({
              title: res.data.msg,
              type: "success",
            });
            $("#collect img").prop(
              "src",
              "https://beinabncc.oss-cn-beijing.aliyuncs.com/file//icon53-120210417.png"
            );
          }
        })
        .catch((err) => {
          Toast({
            title: err.message || "收藏失败，请联系管理员",
            type: "error",
          });
        });
    }

    function standarddownloadcheck() {
      const formData = new FormData();
      formData.append("id", props.pid);
      Toast({
        title: "下载请移步至电脑端：http://www.biaowu.com/",
        type: "warning",
        duration: 3000,
      });
      // api
      // .post("/M/Server/DownloadCheck", formData)
      // .then((res): void => {
      //   if(!res.data.success){
      //     if(res.data.msg == "请先登录！"){
      //         Toast({
      //             title: res.data.msg,
      //             type: "error"
      //         });
      //     }
      //     if(res.data.msg == "账户积分不足,请充值!"){
      //         Toast({
      //             title: res.data.msg,
      //             type: "error"
      //         });
      //     }
      //     if (res.data.msg == "文件不存在,请联系客服!"){
      //          Toast({
      //             title: res.data.msg,
      //             type: "error"
      //         });
      //     }
      //     if(res.data.msg == "您已购买过此标准，再次下载不需要扣除积分。"){
      //         window.location.href = "/M/Server/Download?id=" + props.pid;
      //     }
      //   }else{
      //        const fData = new FormData();
      //         fData.append("id", props.pid);
      //       api.post("/M/Server/StandardPurchase", fData).then(data => {
      //           if(data.data.success){
      //             if(data.data.msg == "请先登录再执行此操作!"){
      //                 Toast({
      //                     title: data.data.msg,
      //                     type: "error"
      //                 });
      //             }
      //             if(data.data.msg == "您已购买过此标准!"){
      //                 window.location.href = "/M/Server/Download?id=" + props.pid;
      //             }
      //           }else{
      //               window.location.href = "/M/Server/Download?id=" + props.pid;
      //           }
      //       })
      //   }

      // })
      // .catch(err => {
      //   Toast({
      //     title: err.msg || "收藏失败，请联系管理员",
      //     type: "error"
      //   });
      // });
    }

    return {
      // handleAddCart,
      collectAction,
      standarddownloadcheck,
      toViewCart,
      detailToApplyOrder,
      addShopCar,
      storgeBackstage,
      userInfo
    };
  },
});
</script>

<style lang="scss" scoped>
footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 50px;
  border-top: 1.012px solid #f4f4f4;
  font-size: 14px;
  color: #666;
  background-color: #fff;
  z-index: 100;
}

footer a {
  font-size: 14px;
  color: #666;
  display: block;
}

.footer-nav {
  position: relative;
}

.footer-li {
  float: left;
  width: 17%;
  text-align: center;
  position: relative;
}

.footer-li img {
  display: block;
  width: 20px;
  height: 20px;
  margin: 5px auto;
}

.footer-li .active-status {
  position: absolute;
  display: none;
  left: 50%;
  margin-left: -10px;
  top: 0;
  z-index: 10;
  background-color: #fff;
}

.footer-nav .active a {
  color: #df0024;
}

.footer-nav .active .active-status {
  display: block;
}

footer .button {
  width: 110px;
  height: 36px;
  line-height: 36px;
  text-align: center;
  background-color: #e7c527;
  color: #fff;
  border-radius: 36px;
  margin-top: 8px;
  margin-right: 11px;
}

footer .button a {
  color: #fff;
}

.buttonHide {
  visibility: hidden;
}
</style>
